// extracted by css-extract-rspack-plugin
export default {"container":"SuspenseFallback-module__container__nmuDaD_","placeholder":"SuspenseFallback-module__placeholder__HeZfcK0"};